import React, { Component } from "react";
import Parse from "parse";
import TextField from "src/components/TextField";
import { withTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";

class ForgotPassword extends Component {
  state = {
    status: this.props.email ? "sent" : "enter",
    email: ""
  };
  inputRef = React.createRef();

  componentDidMount() {
    const { email } = this.props;
    if (email) {
      Parse.User.requestPasswordReset(email);
      return;
    }
    window.addEventListener("keydown", this.handleKeyDown);
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }

  handleEmailChange = ({ target }) => {
    this.setState({ email: target.value });
  };
  sendEmail = () => {
    const { email } = this.state;
    if (this.inputRef.current.reportValidity()) {
      Parse.User.requestPasswordReset(email);
      this.setState({ status: "sent" });
    } else {
      this.inputRef.current.checkValidity();
    }
  };
  handleKeyDown = (e) => {
    const { key } = e;
    const { status } = this.state;
    if (key === "Enter") {
      e.preventDefault();
      status === "enter" ? this.sendEmail() : this.props.onDismiss();
    }
  };

  render() {
    const { status, email } = this.state;
    const { t, onDismiss } = this.props;
    const heading =
      status === "sent"
        ? t("auth.login.forgotPassword.sent.heading")
        : t("auth.login.forgotPassword.enter.heading");
    const text =
      status === "sent"
        ? t("auth.login.forgotPassword.sent.text")
        : t("auth.login.forgotPassword.enter.text");
    const input = (
      <TextField
        reference={this.inputRef}
        required
        autoFocus
        type="email"
        value={email}
        onChange={this.handleEmailChange}
        placeholder={t("placeholders.email")}
        disabled={status !== "enter"}
      />
    );
    const enterButtons = [
      { text: t("buttons.close"), onClick: onDismiss },
      { text: t("buttons.send"), onClick: this.sendEmail }
    ];
    const sentButtons = [{ text: t("buttons.ok"), onClick: onDismiss }];
    return (
      <Dialog
        heading={heading}
        text={text}
        additionalContent={status === "enter" ? input : null}
        buttons={status === "enter" ? enterButtons : sentButtons}
        isOpen={true}
      />
    );
  }
}

export default withTranslation()(ForgotPassword);
